export const TIME_REPORT_SETTINGS_FORM_TOLLERANCE = "TIME_REPORT_SETTINGS_FORM_TOLLERANCE";
export const TIME_REPORT_FORM_DEFAULT_ACTION = "TIME_REPORT_FORM_DEFAULT_ACTION";
export const TIME_REPORT_SUBMIT_SETTINGS_FORM_DATA = "TIME_REPORT_SUBMIT_SETTINGS_FORM_DATA";
export const TIME_REPORT_GET_CURRENT_PARAM = "TIME_REPORT_GET_CURRENT_PARAM";
export const TIME_REPORT_GET_CURRENT_PARAM_SUCCESS = "TIME_REPORT_GET_CURRENT_PARAM_SUCCESS";